import React from "react";
import "./topheader.css";

const AboutSection = ({ title = "ABOUT US", description = "Default description here..." }) => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h1>{title}</h1>
        <p>{description}</p>
        <div className="underline"></div>
      </div>
    </section>
  );
};

export default AboutSection;
